// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__2QHrK","iconRight":"index_iconRight__4bLF9"};